module.exports = __webpack_public_path__ + "static/img/profile.ec4811a6.svg";